import { Component, inject, Input, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { CreditorModel, CreditorService } from '@railmybox/api-user';
import { AbstractValueAccessorComponent, ValueAccessorUtil } from '@railmybox/shared/util';
import { catchError, map, Observable, of, switchMap } from 'rxjs';

@UntilDestroy()
@Component({
  selector: 'rmb-creditor-select',
  templateUrl: './creditor-select.component.html',
  styleUrl: './creditor-select.component.scss',
  providers: [...ValueAccessorUtil.getValueAccessorProvider(CreditorSelectComponent)],
  standalone: false,
})
export class CreditorSelectComponent extends AbstractValueAccessorComponent<string> implements OnInit {
  private creditorService = inject(CreditorService);

  creditors$: Observable<CreditorModel[]>;
  searchControl: FormControl = new FormControl<string | null>(undefined);
  selectedName: string;
  @Input() clearable = true;

  ngOnInit(): void {
    this.creditors$ = this.searchControl.valueChanges.pipe(
      untilDestroyed(this),
      switchMap((query: string) => (query ? this.creditorService.adminListCreditors({ query }) : of([])))
    );
  }

  onSearchValueChanged(query: string): void {
    this.searchControl.patchValue(query);
  }

  onSelect(creditor: CreditorModel): void {
    this.selectedName = creditor ? `${creditor?.name1} (${creditor?.creditorId})` : null;
    this.value = creditor?.creditorId;
    this.onChange(creditor?.creditorId);
    this.changed.emit(creditor?.creditorId);
  }

  writeValue(value: string): void {
    super.writeValue(value);

    if (value) {
      this.creditorService
        .adminGetCreditor(value)
        .pipe(
          untilDestroyed(this),
          map((creditor) => {
            if (creditor) {
              this.value = creditor.creditorId;
              this.selectedName = `${creditor.name1} (${creditor.creditorId})`;
            }
            return of(null);
          }),
          catchError(() => {
            return of(null);
          })
        )
        .subscribe();
    } else {
      this.value = undefined;
      this.selectedName = undefined;
    }
  }
}
